import { render } from "./pointdecaisse.vue?vue&type=template&id=8d28efdc&scoped=true"
import script from "./pointdecaisse.vue?vue&type=script&lang=js"
export * from "./pointdecaisse.vue?vue&type=script&lang=js"

import "./pointdecaisse.vue?vue&type=style&index=0&id=8d28efdc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d28efdc"]])

export default __exports__